FreeBoardLimitInfo = require('app/common/components/create-board/free-board-limit-info').default
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('board_list_item_add')
Util = require 'app/scripts/lib/util'
isDesktop = require('@trello/browser').isDesktop()
localizeCount = require 'app/scripts/lib/localize-count'

module.exports = class extends React.Component
  displayName: 'BoardListItemAddComponent'
  constructor: (props) ->
    super props

    @questionRef = React.createRef()
    @textRef = React.createRef()

    @hidePopOver = @hidePopOver.bind(@)
    @handleOnMouseEnter = @handleOnMouseEnter.bind(@)
    @handleOnMouseLeave = @handleOnMouseLeave.bind(@)

  handleOnMouseEnter: (currentRef) => (e) =>
    { org } = @props
    @setState({ isActive: true })
    limit = org.getFreeBoardLimit()

    if currentRef
      @setState({ currentRef })
    else
      currentRef = @state.currentRef

    textComponent = React.createElement FreeBoardLimitInfo,
      key: 1
      isLimitOverridden: org.isFreeBoardLimitOverridden(),
      isAtOrOverLimit: org.isAtOrOverFreeBoardLimit(),
      isDesktop: isDesktop,
      openBoardCount: limit.count,
      orgName: org.get('displayName'),
      upgradeUrl: org.getBillingUrl(),
      onMouseEnter: @handleOnMouseEnter(currentRef),
      onMouseLeave: @handleOnMouseLeave,

    PopOver.show
      elem: currentRef.current
      maxWidth: '242'
      hideHeader: true
      reactElement: textComponent

  handleOnMouseLeave: ->
    @setState({
      isActive: false
    })
    setTimeout((@hidePopOver), 500)

  hidePopOver: ->
    if !@state.isActive
      PopOver.hide()

  render: t.renderable ->
    { newBoard, preloadData, org } = @props

    if !org?.isPremium()
      preloadData()
      boardsRemaining = org?.getFreeBoardsRemaining()
      showBoardsRemaining = !isDesktop && org?.isCloseToFreeBoardLimit()
      boardsOver = org?.getFreeBoardsOver() || 0
      showBoardsOver = boardsOver > 0

    t.li '.boards-page-board-section-list-item', =>
      t.div '.board-tile.mod-add', { onMouseOver: preloadData, onClick: newBoard }, =>
        t.p ->
          t.format('create-new-board')
        if showBoardsRemaining
          t.p '.remaining', =>
            t.format('count-remaining', { boardsRemaining })
            if showBoardsOver
              t.span '.over-limit-text', =>
                t.text ' | '
                t.span '.boards-over-limit', {
                  onMouseEnter: @handleOnMouseEnter(@textRef),
                  onMouseLeave: @handleOnMouseLeave,
                  ref: @textRef
                }, ->
                  t.a ->
                    t.text localizeCount('boards-over', boardsOver)
          t.div '.question-icon', {
            onMouseEnter: @handleOnMouseEnter(@questionRef),
            onMouseLeave: @handleOnMouseLeave,
            ref: @questionRef
          }, =>
            t.icon 'help'
